module.exports = __webpack_public_path__ + "img/faq1.d17a6969.png";